import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { generatePanelId } from "./panelsSlice.js";

const realtimeEntity = createEntityAdapter({
    selectId: ({ hwaddr, networkId }) => generatePanelId(hwaddr, networkId),
});

const entitySelectors = realtimeEntity.getSelectors( state => state.realtime);

export const realtimeSlice = createSlice({
    name: "realtime",
    initialState: realtimeEntity.getInitialState(),

    reducers: {

        clear: realtimeEntity.removeAll,
        updateRuntimeReport(state, action) {
            realtimeEntity.upsertOne(state, {
                hwaddr: action.payload.hwaddr,
                networkId: action.payload.networkId,
                runtime: action.payload.runtime,
            });
        },
    },
});

// actions

export const updateRuntimeReport = (hwaddr, networkId, runtime) => realtimeSlice.actions.updateRuntimeReport({ hwaddr, networkId, runtime });

// Selectors

export const selectSiteRuntime = (hwaddr, networkId) => state => {
    const rec = entitySelectors.selectById(state, generatePanelId(hwaddr, networkId));
    if(rec)
    {
        console.log({ rec })
        return rec.runtime;
    }
    return false;
}

export const useSiteRuntime = (hwaddr, networkId) => useSelector(selectSiteRuntime(hwaddr, networkId))

export default realtimeSlice.reducer;
